import { section } from "@/neon";

import { focusFormStatus } from "@/lib/a11y";
import { animateNewsletter } from "@/lib/animation";

section("newsletter", {
  onLoad() {
    this.animateNewsletter = animateNewsletter(this.container);
    focusFormStatus(this.container);
  },
  onUnload() {
    this.animateNewsletter?.destroy();
  },
});
